import { Card, FormControl, InputLabel, Link, MenuItem, Paper, Select, TextField, Typography } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Loading from '../../components/Loading';
import { Stack } from '@mui/system';
import { useGetSalesRepContractsQuery, useGetSalesRepDiscountsQuery, useGetSalesRepQuery, useUpdateSalesRepMutation } from '../../features/model/salesrepSlice';
import { useListDiscountsQuery } from '../../features/model/discountSlice';
import { getUser } from '../../features/auth/authSlice';
import { DiscountCard, AddDiscountCard } from './DiscountView';
import { AddContractCard, ContractCard } from './ContractView';
import { SalesRepOrdersListView } from '../../components/OrdersListView';
import { SalesRepFindersListView } from './SalesRepFindersListView';
import { ContactSupportOutlined } from '@mui/icons-material';
import { SalesRepDistributorsListView } from './SalesRepDistributorsListView';

const SalesRepView = () => {
    let params = useParams();
    let [discountQueryParams, setDiscountQueryParams] = useState({"salesrep": params.objectId});
    let [discountFilter, setDiscountFilter] = useState("All");
    const {data: object, error, isLoading } = useGetSalesRepQuery(params.objectId)
    const {data: discounts, error: discountsError, isLoading: isLoadingDiscounts} = useListDiscountsQuery(discountQueryParams)
    const {data: allDiscounts, error: allDiscountsError, isLoading: isLoadingAllDiscounts} = useGetSalesRepDiscountsQuery(params.objectId)
    const {data: contracts, error: contractsError, isLoading: isLoadingContracts} = useGetSalesRepContractsQuery(params.objectId)

    const [updateObject, {isLoadingUpdate: isUpdating }] = useUpdateSalesRepMutation();

    const user = useSelector(getUser)

    if (isLoading || isUpdating || isLoadingDiscounts || isLoadingContracts) {
      return <Loading />
    }

    if (error) {
      return <div>Error: {error.error}</div>
    }
    if (allDiscountsError) {
        return <div>Error: {allDiscountsError.error}</div>
    }

    if (contractsError) {
        return <div>Error: {contractsError.error}</div>
    }

    var allDiscountObjects = []
    if (allDiscounts) {
        allDiscountObjects = allDiscounts.objects
    }
    var filteredDiscounts = []
    if (discounts) {
        filteredDiscounts = discounts.objects
    }
    var contractObjects = []
    if (contracts) {
        contractObjects = contracts.objects
    }

    var distributorsView = (object.type === "rep") ? <Paper>
        <Card>
            <SalesRepDistributorsListView salesrep={object} />
        </Card>
    </Paper> : <></>

    return <Stack sx={{margin: 2}} spacing={2}>
        <Paper>
            <Card>
                <Stack direction="column" sx={{margin: 2}} spacing={2}>
                    <Typography variant='h2'>Sales rep details</Typography>
                    <TextField label="Name" defaultValue={object.name} onChange={(event) => {
                        updateObject({salesrep_id: object.id, data: {name: event.target.value}});
                    }} />
                    <TextField label="Email" defaultValue={object.email} onChange={(event) => {
                        updateObject({salesrep_id: object.id, data: {email: event.target.value}});
                    }} />
                    <TextField label="Password" type="password" defaultValue={object.password} onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                            updateObject({salesrep_id: object.id, data: {password: event.target.value}});
                        }
                    }} />
                    <FormControl>
                        <InputLabel shrink>Status</InputLabel>
                        <Select label="Status" id="status" value={object.status} onChange={(event) => {
                            updateObject({salesrep_id: object.id, data: {status: event.target.value}});
                        }}>
                        <MenuItem key={"active"} value={"active"}>Active</MenuItem>
                        <MenuItem key={"inactive"} value={"inactive"}>Inactive</MenuItem>
                        <MenuItem key={"deleted"} value={"deleted"}>Deleted</MenuItem>
                        </Select>
                        </FormControl>

                </Stack>
            </Card>
        </Paper>
        <Paper>
            <Card>
            <Stack direction="column" sx={{margin: 2}} spacing={2}>
                <Typography variant='h2'>Customer codes</Typography>
                {
                    allDiscountObjects.map((discount, i) => <DiscountCard key={discount.id} discount={discount} />)
                }
                <AddDiscountCard salesrep={object} />
                <Typography variant='p'><b>Distributor registration link:</b> <Link href={`https://leftcoastcabinets.com/distributor?ref=${object.id}`}>https://leftcoastcabinets.com/distributor?ref={object.id}</Link></Typography>
                </Stack>
            </Card>
        </Paper>
        <Paper>
            <Card>
            <Stack direction="column" sx={{margin: 2}} spacing={2}>
                <Typography variant='h2'>Contracts</Typography>
                {
                    contractObjects.map((contract, i) => <ContractCard key={contract.id} object={contract} />)
                }
                <AddContractCard salesrep={object} />
                </Stack>
            </Card>
        </Paper>
        <Paper>
            <Card>
                <Stack sx={{margin: 2}} spacing={2}>
                    <FormControl>
                        <InputLabel id="demo-simple-select-label">Code</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={discountFilter}
                            label="Code"
                            onChange={(event) => {
                                if (event.target.value == "All"){
                                    setDiscountQueryParams({"salesrep": discountQueryParams.salesrep})
                                } else {
                                    setDiscountQueryParams({"salesrep": discountQueryParams.salesrep, "code": event.target.value})
                                }
                                setDiscountFilter(event.target.value)
                            }}
                        >
                            <MenuItem value="All">All</MenuItem>
                            {allDiscountObjects.map((discount, i) => <MenuItem value={discount.code}>{discount.code}</MenuItem>)}
                        </Select>
                    </FormControl>
                    <SalesRepOrdersListView salesrep={object} contracts={contractObjects} discounts={filteredDiscounts.map((discount, i) => discount.id) } admin={true} />
                </Stack>
            </Card>
        </Paper>
        <Paper>
            <Card>
                <SalesRepFindersListView salesrep={object} contracts={contractObjects} admin={true} />
            </Card>
        </Paper>
    </Stack>;
}

export default SalesRepView;
